








import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'

@Component({
  components: {}
})
export default class SignedTextView extends Vue {
  @Prop() value!: number | string
  @Prop({ default: '%' }) sign !: string
  @Prop() ltr!: boolean
  @Prop() signClass!: string

  private ltrStyle = {
    direction: 'ltr'
  }

}
